export default __webpack_public_path__ + "static/media/annex11.77ce9505.png";